import PropTypes from "prop-types";
import TableWithCheckboxes from "../../../components/ui/tables/table-with-checkboxes/TableWithCheckboxes";
import React from "react";
import {returnSelectedRows} from "../../utils/tableUtils";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Checkbox from "@material-ui/core/Checkbox";
import TagsCell from "../../../components/mobile/sub-menu-items/sim/tabs/attive/attive-table/tags-cell/tags/Tags";
import EmptyRow from "../../../components/ui/tables/rows/empty-row/EmptyRow";
import HourglassIconAndTooltipCell
    from "../../../components/ui/tables/cells/hourglass-icon-and-tooltip-cell/HourglassIconAndTooltipCell";

const SimServerSideTable = (props) => {
    const handleClick = (event, sim) => {
        event.stopPropagation();
        const selectedIndex = props.selected.findIndex(i => i.id === sim.id);
        props.setSelected(returnSelectedRows(props.selected, sim, selectedIndex));
    };

    const getSimTableTooltipContent = (row) => {
        return [
            {textLeft: row.wrenchDto.titleLabelFirstRow, textRight: row.wrenchDto.labelFirstRow},
            {textLeft: row.wrenchDto.titleLabelSecondRow, textRight: row.wrenchDto.labelSecondRow}
        ];
    }

    const isSelected = (id) => props.selected.some(s => s.id === id);
    const tableRows = (
        props.count !== 0 ? props.tableData.map((row, index) => {
            const isItemSelected = isSelected(row.id);
            const labelId = `soglie-associate-remove-table-checkbox-${index}`;

            return (
                <TableRow hover
                          onClick={(event) => handleClick(event, row)}
                          role="checkbox"
                          aria-checked={isItemSelected}
                          tabIndex={-1}
                          key={row.seriale}
                          selected={isItemSelected}
                >
                    <TableCell padding="checkbox">
                        <Checkbox
                            checked={isItemSelected}
                            onClick={(e) => handleClick(e, row)}
                            inputProps={{'aria-labelledby': labelId}}
                        />
                    </TableCell>
                    <TableCell align="left">{row.numeroDiTelefono}</TableCell>
                    <TableCell align="left">{row.seriale}</TableCell>
                    <TableCell align="left">{row.piano}</TableCell>
                    {row.tags ? <TableCell align="left"><TagsCell tags={row.tags}/></TableCell> : <TableCell/>}
                    <TableCell align="right" className="wrench-tooltip-cell">
                        {row.wrenchDto && row.wrenchDto.showWrench ? <HourglassIconAndTooltipCell
                                tooltipContent={getSimTableTooltipContent(row)}/>
                            : null}
                    </TableCell>
                </TableRow>
            );
        }) : <EmptyRow text="dato" colSpan={props.headCells.length + 2}/>)

    return <TableWithCheckboxes selected={props.selected}
                                setSelected={props.setSelected}
                                page={props.page}
                                fetchData={props.handlePaginationChange}
                                rowsPerPage={props.rowsPerPage}
                                rows={props.tableData}
                                tableRows={tableRows}
                                headCells={props.headCells}
                                count={props.count}
                                loading={props.loading}
                                selectAllRows={props.areAllSelected}
                                setSelectAllRows={props.setAreAllSelected}/>
}

SimServerSideTable.propTypes = {
    tableData: PropTypes.array.isRequired,
    selected: PropTypes.array.isRequired,
    setSelected: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
    loading: PropTypes.bool.isRequired,
    order: PropTypes.string.isRequired,
    filter: PropTypes.object.isRequired,
    handlePaginationChange: PropTypes.func.isRequired,
    areAllSelected: PropTypes.bool.isRequired,
    setAreAllSelected: PropTypes.func.isRequired,
    headCells: PropTypes.array.isRequired,
    count: PropTypes.number.isRequired
}

export default SimServerSideTable
